import { InputAdornment } from '@mui/material';
import { RHFTextField } from '../hook-form';

import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persianFa from 'react-date-object/locales/persian_fa';
import TimePicker from 'react-multi-date-picker/plugins/time_picker';
import 'react-multi-date-picker/styles/colors/green.css';
import Iconify from '../Iconify';
import { convertFaToEnDigits } from 'src/utils/formatNumber';

const GeneralTimePicker = ({ label, name, value, onChangeValue, type, setManipulatedStartTime, setManipulatedEndTime }) => {
  return (
    <DatePicker
      disableDayPicker
      format="HH:mm:ss"
      plugins={[<TimePicker />]}
      value={value}
      onChange={(date) => {
        const formattedTime = date?.format('HH:mm:ss');
        const englishTime = convertFaToEnDigits(formattedTime);
        onChangeValue(date);
        if (type === "start") setManipulatedStartTime(englishTime);
        else setManipulatedEndTime(englishTime);
      }}
      calendar={persian}
      locale={persianFa}
      calendarPosition="bottom-right"
      zIndex={99999}
      className="green"
      fixMainPosition
      style={{
        fontFamily: 'IR-Yekan',
      }}
      render={(value, openCalendar) => (
        <RHFTextField
          name={name}
          value={value}
          type="text"
          label={label}
          onClick={openCalendar}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Iconify icon={'carbon:time'} width={27} height={27} />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  );
};

export default GeneralTimePicker;
